define('vspot-angular/services/org-job-assignment-service',[], function () {
    'use strict';

    return ['resources.OrgJobAssignment', '$rootScope', function (OrgJobAssignment, $rootScope) {

        return {
            /*
             * Get a list of all the jobs for an activity. Results are paginated.
             *
             * @param activityId - ID of the activity for which to fetch assignments.
             * @param jobId - ID of the job for which to fetch assignments.
             * @param currentPage - Which page of the result set to show. 1 is the default.
             * @param itemsPerPage - How many items to show on each page of the result set. 10 is the default.
             *
             * @returns  Resource object. See /resources.js documentation for details
             */
            query: function(activityId, jobId, currentPage, itemsPerPage) {
                return OrgJobAssignment.query({
                    selected_activity:  activityId,
                    selected_job:       jobId,
                    page:               currentPage,
                    items_per_page:     itemsPerPage
                });
            },

            get: function (id, activityId) {
                return OrgJobAssignment.get({ id: id, selected_activity:  activityId});
            },

            save: function(postData) {
                return OrgJobAssignment.save(postData);
            },

            update: function (id, activityId, newQty) {
                return OrgJobAssignment.update({ id: id, selected_activity: activityId, quantity: newQty });
            },
            
            delete: function(id, activityId, deleteAll) {
                var params = {
                    id: id,
                    selected_activity:  activityId
                };

                if( !global_helper.blank(deleteAll) && deleteAll === true ) {
                    params.delete_all = 'true';
                }

                return OrgJobAssignment.delete(params);
            }
        };
    }];
});

